import Image from "next/image";
import Link from "next/link";
import parse, { domToReact } from "html-react-parser";

export default function ProgramCard({ name, desc, img }) {
  return (
    <li>
      <Link href={`/program/${name}`}>
        <div className="col-span-1 flex h-40 cursor-pointer space-x-3 rounded-xl border p-4 hover:bg-blue-100 hover:opacity-80">
          <div className="flex w-2/3 flex-col space-y-2 font-nunito">
            <h2 className="text-xl font-bold capitalize">{name}</h2>
            <p
              className="program-text prose !max-w-full text-sm font-normal"
              dangerouslySetInnerHTML={{
                __html: desc,
              }}
            ></p>
          </div>
          <div className="relative flex h-full w-1/3 items-center justify-center">
            <Image
              src={img}
              alt={name}
              height={100}
              width={100}
              objectFit="contain"
              priority={true}
            />
          </div>
        </div>
      </Link>
      <style jsx>
        {`
          p.program-text {
            display: -webkit-box;
            max-width: 100%;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
        `}
      </style>
    </li>
  );
}
